/*  ========================================================================
    # Hero Image Slider - Index
    ========================================================================  */

import React from 'react';
import { createRoot } from 'react-dom/client';
import HeroImageSlider from './HeroImageSlider';

const containers = document.querySelectorAll('div[data-react-app="HeroImageSlider"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = containers[i].attributes['data-guid']?.value;
  const props = window.reactProps[containerGuid];

  createRoot(containers[i]).render(<HeroImageSlider {...props} />);
}
